import Layout from "./components/Layout";
import Page from "./components/Page";

import useStoryblok from "../../lib/storyblok-hook";

export default function BlogBodyContainer(props) {
  const story = useStoryblok(props.story);
  // console.log("editscene", story);
  let sidebarcontent= props.sidebar.content ?props.sidebar.content:props.sidebar.story.content

  return (
    <>
      <div className="center_container">
        <div className="container px-4">
          <div className="row">
            <div className="w-full lg:w-9/12">
              {props.full == true ? (
                <Layout>
                  <div className="py-6">
                    <Page
                      full={true}
                      content={story.content}
                      published_at={story.published_at}
                    />
                  </div>
                </Layout>
              ) : (
                <Layout>
                  {props.stories.map((story) => {
                    return (
                      <>
                        <div className="py-6" key={story.id}>
                          {/* <a href={"/blog/" + story.slug}> */}
                            <Page full={false} content={story.content} published_at={story.published_at} slug={story.full_slug}/>

                          {/* </a> */}
                        </div>
                      </>
                    );
                  })}
                </Layout>
              )}
            </div>
            <div className="w-full lg:w-3/12 pt-12">
              <Layout>
                <Page full={props.full} content={sidebarcontent} />
              </Layout>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
